// extracted by mini-css-extract-plugin
export default {"crop":"ImageCrop_crop__D0yls"};